// Vendors
import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import algoliasearch from 'algoliasearch/lite';
import { InstantSearch, SortBy, Configure } from 'react-instantsearch-dom';
import aa from 'search-insights';
import qs from 'qs';
import debounce from 'lodash/debounce';

// Components
import globalLoader from '../../site/global-loader';
import { Pagination } from '../../algolia/components';
import {
  FacetList,
  ProductHits,
  ResultsFoundHeader,
  SearchField
} from './components';

// Helpers
import { scrollToElement } from '../../lib/utilities';

// Data
import {
  environment,
  ALGOLIA_APP_ID,
  ALGOLIA_SEARCH_API_KEY,
  ALGOLIA_INDEX
} from '../../config/index';

// Check if wlProductFacet exists on window and has the needed properties
const productFacet = window.wlProductFacet || {};
const { product_type, product_type_class } = productFacet;

const searchClient = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_SEARCH_API_KEY);
window.aa = aa('init', {
  appId: ALGOLIA_APP_ID,
  apiKey: ALGOLIA_SEARCH_API_KEY,
  useCookie: true
});

const getQueryID = () => {
  const url = new URL(window.location.href);
  const searchParams = url.searchParams;

  const queryID = searchParams.get('queryID');
  return queryID;
};
let userToken = '';
aa('getUserToken', null, (err, algoliaUserToken) => {
  userToken = algoliaUserToken;
});

const createURL = (state) => {
  const queryParameters = {};

  if (!state) return;

  if (state.page !== 1) queryParameters.page = state.page;
  if (state.query) queryParameters.query = encodeURIComponent(state.query);
  if (state.sortBy) {
    // Abbreviate 'sortby' param (index name)..
    const sortByName = state.sortBy.replace(
      `burrell_${environment}_product_catalog`,
      ''
    );

    // ..and only write queryParam if we've selected a replica index (and abbreviate some more)
    if (sortByName !== '') {
      queryParameters.sortBy = sortByName.replace('_replica_', '');
    }
  }

  // Abbreviate facets from 'facets.pa_{facet}' to '_{facet}'
  if (state.refinementList) {
    Object.keys(state.refinementList).map((facet) => {
      if (state.refinementList[facet].length) {
        const facetName = facet.replace('facets.pa', '');
        queryParameters[facetName] = encodeURIComponent(
          state.refinementList[facet]
        );
      }
    });
  }

  const queryString = qs.stringify(queryParameters, {
    addQueryPrefix: true,
    arrayFormat: 'repeat'
  });

  return queryString ? queryString : window.location.pathname;
};

const searchStateToUrl = (searchState) =>
  searchState ? createURL(searchState) : '';

const urlToSearchState = (location) => {
  if (!location) return;

  const queryString = qs.parse(location.search.slice(1));
  const { query = '', page = 1, sortBy = ALGOLIA_INDEX.main } = queryString;
  const refinementList = {};
  let sortByParsed = sortBy;

  // Rename sortBy to proper index name so app state can be updated (only applies to replicas)
  if (queryString.sortBy)
    sortByParsed = `burrell_${environment}_product_catalog_replica_${sortBy}`;

  // Rename facets to proper facet names so app state can be updated
  Object.keys(queryString).map((facet) => {
    if (facet.charAt(0) === '_') {
      const facetString = () =>
        queryString[facet].includes('&amp;')
          ? queryString[facet].replace('&amp;', '&')
          : queryString[facet];

      refinementList[`facets.pa${facet}`] = decodeURIComponent(
        facetString()
      ).split(',');
    }
  });
  return {
    query: decodeURIComponent(query),
    page,
    sortBy: sortByParsed,
    refinementList
  };
};

const updateHistory = debounce(
  (updatedSearchState) =>
    window.history.pushState(
      searchStateToUrl(updatedSearchState),
      updatedSearchState,
      searchStateToUrl(updatedSearchState)
    ),
  500,
  { leading: true, trailing: true }
);

const ResourceCatalog = () => {
  const { location } = window;
  // Check for product_type and set the default refinement list
  const defaultRefinementList = product_type
    ? {
        'facets.pa_product-type': [product_type]
      }
    : {};

  const [searchState, setSearchState] = useState({
    query: '',
    page: 1,
    sortBy: ALGOLIA_INDEX.mostPopular,
    refinementList: defaultRefinementList // use the value here
  });
  const [catalogIsReady, setCatalogIsReady] = useState(false);
  const [catalogIsLoading, setCatalogIsLoading] = useState(false);
  const [mobileFilterToggle, setMobileFilterToggle] = useState(false);
  const onSearchStateChange = (updatedSearchState) => {
    const queryChanged = searchState.query !== updatedSearchState.query;
    if (queryChanged) {
      setSearchState(updatedSearchState);
      updateHistory(updatedSearchState);
    } else {
      // Filters Changed
      setCatalogIsLoading(true);
      scrollToElement('#search-section');
      setTimeout(function () {
        setMobileFilterToggle(false);
        setSearchState(updatedSearchState);
        updateHistory(updatedSearchState);
        setCatalogIsLoading(false);
      }, 800);

      // Log Filter Change
      // This requires the `search-insights` library
      // aa('clickedFilters', {
      //   userToken: userToken,
      //   index: ALGOLIA_INDEX.main,
      //   eventName: 'Product Catelog Filter Changed',
      //   filters: updatedSearchState.refinementList
      // });
    }
  };

  const toggleMobileFilters = () => {
    if (mobileFilterToggle) {
      setMobileFilterToggle(false);
    } else {
      setMobileFilterToggle(true);
    }
  };

  useEffect(() => {
    let loaded = new Promise((resolve, reject) => {
      if (searchClient) resolve(searchClient);

      return reject(
        new Error(
          'Product Catalog search client failed in loading. Please refresh the page to try again.'
        )
      );
    });

    loaded.then(() => {
      if (window.location.search !== '') {
        setSearchState(urlToSearchState(location));
      }
      setCatalogIsReady(true);
    });
  }, []);

  $('html').on('click', `.ais-Hits .ais-Hits-item .card-product`, (event) => {
    aa('clickedObjectIDsAfterSearch', {
      userToken,
      eventName: 'Product Clicked From Catelog',
      index: ALGOLIA_INDEX.main,
      objectIDs: [event.currentTarget.getAttribute('data-object-id')],
      positions: [
        parseInt(event.currentTarget.getAttribute('data-object-position'))
      ],
      queryID: getQueryID()
    });
  });

  return (
    <InstantSearch
      searchClient={searchClient}
      indexName={ALGOLIA_INDEX.main}
      searchState={searchState}
      onSearchStateChange={onSearchStateChange}
    >
      <Configure hitsPerPage={15} clickAnalytics />
      {catalogIsReady && (
        <>
          <div className="grid">
            <div className="grid__col-xs-12 grid__col-md-3 grid__col-lg-4 grid__col-xl-3">
              <aside
                className={`product-sidebar product-sidebar--${product_type_class}`}
              >
                <div className="callout-search__search">
                  <SearchField />
                </div>
              </aside>
            </div>
            <div className="grid__col-xs-12 grid__col-md-9 grid__col-lg-8 grid__col-xl-9">
              <div className="app-product-catalog__headers grid grid--between grid--middle grid--reverse">
                <div className="grid__col-xs-12 grid__col-sm-12 grid__col-md-6 u--display-none-sm-max">
                  <form className="related-content__filters">
                    <div className="form__field u--margin-bottom-0 u--margin-right-5 sort-by-container">
                      <span className="u--margin-right-5">Sort By:</span>
                      <SortBy
                        defaultRefinement={ALGOLIA_INDEX.asc}
                        currentRefinement={(e) => e.currentTarget.value}
                        items={[
                          {
                            value: ALGOLIA_INDEX.main,
                            label: 'Relevance'
                          },
                          {
                            value: ALGOLIA_INDEX.asc,
                            label: 'A-Z'
                          },
                          {
                            value: ALGOLIA_INDEX.desc,
                            label: 'Z-A'
                          },
                          {
                            value: ALGOLIA_INDEX.recentlyAdded,
                            label: 'Recently Added'
                          },
                          {
                            value: ALGOLIA_INDEX.mostPopular,
                            label: 'Most Popular'
                          },
                          {
                            value: ALGOLIA_INDEX.priceHighLow,
                            label: 'Price: High to Low'
                          },
                          {
                            value: ALGOLIA_INDEX.priceLowHigh,
                            label: 'Price: Low to High'
                          }
                        ]}
                        className="form__select form__select--alt form__select--lg"
                      />
                    </div>
                  </form>
                </div>
                <div className="grid__col-xs-12 grid__col-sm-12 grid__col-md-6">
                  <ResultsFoundHeader />
                </div>
              </div>
            </div>
          </div>

          <div className="grid">
            <div className="grid__col-xs-12 grid__col-md-3 grid__col-lg-4 grid__col-xl-3">
              <div
                className={`product-filters product-filters--${
                  mobileFilterToggle ? 'visible' : ''
                }`}
              >
                <div className="product-sidebar__sory-by u--display-none-md-min">
                  <form className="related-content__filters">
                    <div className="form__field u--margin-bottom-0 u--margin-0 sort-by-container">
                      <span className="u--margin-right-5">Sort By:</span>
                      <SortBy
                        defaultRefinement={ALGOLIA_INDEX.asc}
                        currentRefinement={(e) => e.currentTarget.value}
                        items={[
                          {
                            value: ALGOLIA_INDEX.asc,
                            label: 'A-Z'
                          },
                          {
                            value: ALGOLIA_INDEX.desc,
                            label: 'Z-A'
                          },
                          {
                            value: ALGOLIA_INDEX.recentlyAdded,
                            label: 'Recently Added'
                          },
                          {
                            value: ALGOLIA_INDEX.mostPopular,
                            label: 'Most Popular'
                          },
                          {
                            value: ALGOLIA_INDEX.main,
                            label: 'Relevance'
                          },
                          {
                            value: ALGOLIA_INDEX.priceHighLow,
                            label: 'Price: High to Low'
                          },
                          {
                            value: ALGOLIA_INDEX.priceLowHigh,
                            label: 'Price: Low to High'
                          }
                        ]}
                        className="form__select form__select--alt form__select--lg"
                      />
                    </div>
                  </form>
                </div>
                <dl
                  className="accordion accordion__product-filter"
                  data-toggle-group="accordion-product-filter"
                >
                  <dt
                    className="accordion__header toggle__switch"
                    data-toggle-switch="accordion-product-filter-facets"
                    onClick={toggleMobileFilters}
                  >
                    <p className="u--margin-0">Filter By</p>
                  </dt>
                  <dd
                    className={`toggle__target toggle__target--${
                      mobileFilterToggle ? 'visible' : ''
                    }`}
                    data-toggle-target="accordion-product-filter-facets"
                  >
                    <div className="accordion__content">
                      <aside
                        className={`product-sidebar product-sidebar--${product_type_class}`}
                      >
                        <div className="product-sidebar__facets">
                          <FacetList />
                        </div>
                      </aside>
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
            <div className="grid__col-xs-12 grid__col-md-9 grid__col-lg-8 grid__col-xl-9">
              <ProductHits loading={catalogIsLoading} />

              <div className="grid grid--middle">
                <div className="grid__col-xs-12 grid__col-md-6 grid__col-lg-6 u--padding-top-10">
                  <ResultsFoundHeader />
                </div>
                <div className="grid__col-xs-12 grid__col-md-6 grid__col-lg-6">
                  <div className="section--sm u--padding-bottom-0">
                    <Pagination padding={1} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </InstantSearch>
  );
};

export default ResourceCatalog;
